"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DownloadOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29 22a1 1 0 00-1 1v5H4v-5a1 1 0 00-2 0v5.25A1.62 1.62 0 003.5 30h25a1.62 1.62 0 001.5-1.75V23a1 1 0 00-1-1z"/><path d="M15.29 23.71a1 1 0 00.33.21.94.94 0 00.76 0 1 1 0 00.33-.21l6-6a1 1 0 00-1.42-1.42L17 20.59V3a1 1 0 00-2 0v17.59l-4.29-4.3a1 1 0 00-1.42 1.42z"/>';
var DownloadOutlineSVG = function DownloadOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.DownloadOutlineSVG = DownloadOutlineSVG;
DownloadOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(DownloadOutlineSVG);
exports.default = _default;